export default __webpack_public_path__ + "static/media/iconGreatBack.ecb08f48.svg";